import React, { useContext, useCallback } from "react";
import {
  AppBar,
  Toolbar,
  CssBaseline,
  Typography,
  makeStyles,
} from "@material-ui/core";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { AppContext } from "../context";
import { LOCALES } from "../../i18n";
import { default as translate } from '../../i18n/translate'
import CustomizedMenus from "./menu";

const useStyles = makeStyles(() => ({
 logo: {
    flexGrow: "1",
    cursor: "pointer",
  },
}));

export default function NavbarMobile() {
  const {state, dispatch} = useContext(AppContext);
  const classes = useStyles();
  const [alignment, setAlignment] = React.useState('web');
  
  const setLanguage = useCallback((locale) => {
    dispatch({
      type: 'setLocale',
      locale
    })
  },[dispatch])

  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  return (
    <AppBar position="static" style={{ background: '#307B5B', width: "100%" }}>
      <CssBaseline />
      <Toolbar>
        <Typography variant="h4" style={{width: "20%"}} className={classes.logo}>{translate("navbar.ami")}</Typography>
        <CustomizedMenus/>
            <ToggleButtonGroup
              color="primary"
              value={alignment}
              exclusive
              onChange={handleChange}
              aria-label="Platform"
              style={{backgroundColor: "white", width: "5.2rem"}}
            >
              <ToggleButton disabled={state.locale === LOCALES.FRENCH} onClick={() => setLanguage(LOCALES.FRENCH)} style={{fontWeight: "bold"}} value="french">FR</ToggleButton>
              <ToggleButton disabled={state.locale === LOCALES.ENGLISH} onClick={() => setLanguage(LOCALES.ENGLISH)} style={{fontWeight: "bold"}} value="english">EN</ToggleButton>
            </ToggleButtonGroup>
      </Toolbar>
    </AppBar>
  );
}